var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 54,
    viewBox: "0 0 75 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0069 4.18204C72.1699 5.35252 73.005 6.80801 73.4283 8.40274C74.511 14.3983 75.0365 20.4809 74.998 26.5731C75.0365 32.6656 74.511 38.7482 73.4283 44.7436C73.005 46.3384 72.1699 47.7939 71.0069 48.9642C69.8441 50.1348 68.3939 50.9793 66.8019 51.4129C57.08 52.5843 47.2914 53.1124 37.4999 52.9931C27.7085 53.1124 17.9198 52.5843 8.19797 51.4129C6.606 50.9793 5.15593 50.1348 3.99297 48.9642C2.83 47.7939 1.99499 46.3384 1.57154 44.7436C0.488825 38.7482 -0.0366008 32.6656 0.00197956 26.5731C-0.0366008 20.4809 0.488825 14.3983 1.57154 8.40274C1.99499 6.80801 2.83 5.35252 3.99297 4.18204C5.15593 3.01155 6.606 2.16716 8.19797 1.73345C17.9198 0.56193 27.7085 0.0340168 37.4999 0.15318C47.2914 0.0340168 57.08 0.56193 66.8019 1.73345C68.3939 2.16716 69.8441 3.01155 71.0069 4.18204ZM29.8291 15.4203V37.7263L49.4298 26.5732L29.8291 15.4203Z",
    fill: "#B7B7B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.adbc31f9ef230e34f58a6586c59d2ec4.svg";
export { ForwardRef as ReactComponent };